/**
 * This file holds computed state properties
 * Please refer to https://vuex.vuejs.org/guide/getters.html for more information
 * Getters need to be sync methods
 */

const getters = {
  checkMultipart(store, getters, rootState, rootGetters) {
    if (!rootState.utils.pdm) return 0;
    let componentName = store.features[store.activeUGCIndex].activeUGCComponent;
    if (!componentName)
      componentName = rootGetters["ugc/getUGCEnabledComponents"][0];
      if (rootState.recipe.recipe_v2.components[componentName].group === "graphics") return;
      return rootState.utils.pdm.components[componentName].ugc.placements.length;
  },
  getActiveUGCIndexFeature(store) {
    return store.features[store.activeUGCIndex];
  },
  getActiveUGCIndexId(store) {
    return store.ugcIndex[store.activeUGCIndex] ?? 'ugc';
  },
  getPlacementViewOrder(store) {
    return store.features[store.activeUGCIndex].placementViewOrder;
  },
  getActiveUGCComponent(store) {
    return store.features[store.activeUGCIndex].activeUGCComponent;
  },
  getRecipe(store) {
    return store.features[store.activeUGCIndex].recipe;
  },
  originalImageId(state, getters, rootState) {
    // checks if the component in the current recipe is UGC and returns its original image id
    const originalComponent = (rootState.recipe.recipe_v2 && rootState.recipe.recipe_v2.components) ? rootState.recipe.recipe_v2.components[state.features[state.activeUGCIndex].activeUGCComponent] : {};
    const isOriginalRecipeUgc = !!originalComponent.ugc;
    if (!isOriginalRecipeUgc) return null;
    return originalComponent.ugc.original_image.image_id;
  },
  uploadedAnotherImage(state, getters, rootState) {
    // compares the secondary (when it exists) or UGC image (default) id from the URL with the one in the recipe original image
    const imageParam = rootState.utils.queryParams.secondaryImage || rootState.utils.queryParams.ugcImage;
    const originalImageId = getters.originalImageId;
    if (originalImageId) return imageParam !== originalImageId;
    // if the recipe isn't UGC then compare with the image id in tempData
    const imageId = state.features[state.activeUGCIndex].ugc_image_id;
    return imageParam !== imageId;
  },
};

export default getters;
